import React, { Component } from 'react';
import { Link, Router, Route, browserHistory } from 'react-router';
import './App.css';
import George from './george.jpg';
import Dean from './dean.jpg';
import Jackie from './jackie.jpg';

class About extends Component {
  render() {
    return (
      <div className="about">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <h1>About</h1>
              <p>Fisher & Bagley CPA's was formed in 1976 when Jack
Fisher, CPA, and Dean A. Bagley CPA, JD, joined
forces to provide the highest level of tax services to the
Bay Area. In 2002, George Fisher followed in his
father's footsteps and became his successor to the firm
and has continued his father's legacy. Over 40 years
later, Fisher & Bagley CPA's has grown to include two
managing partners, two staff certified public
accountants, and an exceptional administrative team
who continue to strive in assisting our clients with their
accounting needs. In 2019, as Dean Bagley retired
from the Partnership, Jacqueline Ho took over and
became a new Partner. The firm is renamed as Fisher
& Ho, CPA’s starting 2020.</p>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 partner">
              <img src={George} className="partner-img"/>
              <h2>George A. Fisher CPA</h2>

              <h3>Experience:</h3>
              <ul>
                <li>Partner to Fisher & Bagley for over 15 years</li>
                <li>Associate for over 15 years prior to becoming a partner at Fisher & Bagley</li>
              </ul>

              <h3>Credentials:</h3>
              <ul>
                <li>Current officer of a private foundation that helps Bay Area charities</li>
                <li>CPA with a Bachelor's degree from Menlo College</li>
                <li>Successful business owner of 15+ years</li>
                <li>Real Estate owner/manager-professional</li>
              </ul>

              <h3>Member of:</h3>
              <ul>
                <li>San Bruno Lions Club (former President)</li>
                <li>San Bruno Chamber of Commerce</li>
                <li>South San Francisco Elks Club</li>
                <li>California CPA Society</li>
              </ul>


            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 partner">
              <img src={Jackie} className="partner-img"/>
              <h2>Jacqueline S. Ho CPA</h2>

              <h3>Experience:</h3>
              <ul>
                <li>Over 20 years of experience in Quickbook accounting,
individual and business taxation, and consulting</li>
                <li>Successfully resolving clients’ tax issues with IRS, FTB,
and EDD</li>
                <li>Successfully assisting new clients in resolving substantial
first time penalty abatements</li>
                <li>Experienced in resolving Corporation’s suspension status</li>
              </ul>

              <h3>Credentials:</h3>
              <ul>
                <li>Certified Public of Accountant, State of California</li>
                <li>Golden Gate University, San Francisco; M.S. in Taxation</li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js